import { Nav_log } from '../Navbar/NavbarElements'
import './Navbar2.css'

const Navbar2 = () => {
  return (
    <div className='Navbar2'>
        <ul className='list'>
            <li>
                <Nav_log to='/'>
                    Produkter
                </Nav_log>
            </li>
             <li>
                <Nav_log to='/about'>
                    Om Oss
                </Nav_log>
            </li>
        </ul>
    </div>
  )
}

export default Navbar2